import React from "react"
import { Link, useStaticQuery, graphql } from "gatsby"
import {
  SimpleGrid,
  Container,
  Heading,
  Button,
  Flex,
  Text,
} from "@chakra-ui/react"
import { Icon } from "../../"

import PackagePopular from "./PackagePopular"
import PackageHeading from "./PackageHeading"
import PackageButton from "./PackageButton"
import PackageList from "./PackageList"

export function Packages() {
  const { dataJson } = useStaticQuery(graphql`
    query {
      dataJson {
        packages {
          primary {
            name
            features
            price
          }
          secondary {
            name
            features
            price
          }
          tertiary {
            name
            features
            price
          }
        }
      }
    }
  `)

  const { primary, secondary, tertiary } = dataJson.packages

  return (
    <Container as="section" id="packages">
      <Heading size="3xl" textAlign="center" mb={16} fontWeight="semibold">
        Packages
      </Heading>

      <SimpleGrid columns={{ base: 1, lg: 3 }} spacing={{ base: 8, lg: 0 }}>
        <Flex
          layerStyle="foreground"
          flexDirection="column"
          borderRadius={5}
          bg="base.d100"
          maxW="520px"
          mx="auto"
          flex={1}
          w="full"
          py={12}
          px={6}
        >
          <PackageHeading name={secondary.name} price={secondary.price} />
          <PackageList list={secondary.features} />
          <PackageButton name={secondary.name} />
        </Flex>

        <Flex
          transform={{ base: "none", lg: "scale(1.1)" }}
          order={{ base: -1, lg: 0 }}
          layerStyle="foreground"
          flexDirection="column"
          position="relative"
          borderRadius={5}
          bg="base.900"
          maxW="520px"
          mx="auto"
          flex={1}
          w="full"
          py={12}
          px={6}
        >
          <PackagePopular />
          <PackageHeading name={primary.name} price={primary.price} />
          <PackageList list={primary.features} />
          <PackageButton name={primary.name} />
        </Flex>

        <Flex
          layerStyle="foreground"
          flexDirection="column"
          borderRadius={5}
          bg="base.d400"
          maxW="520px"
          mx="auto"
          flex={1}
          w="full"
          p={12}
        >
          <PackageHeading name={tertiary.name} price={tertiary.price} />
          <PackageList list={tertiary.features} />
          <PackageButton name={tertiary.name} />
        </Flex>
      </SimpleGrid>

      <Button
        colorScheme="primary"
        alignSelf="center"
        to={"/services"}
        variant="ghost"
        size="sm"
        as={Link}
        mt={16}
      >
        <Text as="span" lineHeight={1} fontSize="sm" fontWeight="bold">
          All services
        </Text>

        <Icon name="arrowRight" boxSize={4} ml={3} />
      </Button>
    </Container>
  )
}
